import React from "react";
import GlgTextInput from "../../shared/components/glg_text_input";
import { setNameFilter } from "../store/filtersSlice";
import { useDispatch } from "react-redux";
import { useState, useEffect } from "react";

export const CourseCondensedFilters = ({showAllFilters, toggleShowAllFilters}) => {
  const dispatch = useDispatch()

  const [searchTerm, setSearchTerm] = useState("");

  const handleChange = (value) => {
    setSearchTerm(value)
  }

  useEffect(() => {
    const handler = setTimeout(() => {
      dispatch(setNameFilter(searchTerm));
    }, 500);

    return () => clearTimeout(handler);
  }, [searchTerm, dispatch]);

  return(
    <div className="condensed-filters-container">
      <a href='#' className="filters-link" onClick={toggleShowAllFilters}>
        <i className='fa fa-bars courses-filter-icon'></i>
        {showAllFilters ? window.I18n.t('courses.hide_filters') : window.I18n.t('courses.show_filters')}
      </a>
      <GlgTextInput onChange={handleChange} withAddon={true} value={searchTerm}/>
    </div>
  )
}